import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';

@Component({
  selector: 'h3-page-loading-overlay',
  templateUrl: './page-loading-overlay.component.html',
  styleUrl: './page-loading-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-overlay]': 'withOverlay',
  },
  standalone: false,
})
export class PageLoadingOverlayComponent extends InjectableSuperclass {
  withOverlay = false;

  constructor(workspaceLoadingService: WorkspaceLoadingService) {
    super();
    this.subscribeTo(
      workspaceLoadingService.withOverlay$,
      (withOverlay) => (this.withOverlay = withOverlay),
    );
  }
}
